import $ from "jquery";

const selectors = {
	action: {
		checkoutButton: "[data-action='new-checkout']"
	},
	helpers: {
		cartJsonUrl: "/cart?view=object-json",
		apiVersion: "/api/2022-01/graphql.json",
		publicVariantId: "gid://shopify/ProductVariant/",
		checkoutKey: window.api_key
	}
};

if (selectors.helpers.checkoutKey) {
	$(document).on("click", selectors.action.checkoutButton, function () {
		event.preventDefault();
		$.get(selectors.helpers.cartJsonUrl)
			.done(function (data) {
				CreateLineItems(data);
			})
			.fail(function (err) {
				console.log(err);
			});
	});
}

function CreateLineItems(cartData) {
	let lineItems = [];
	const html = document.createElement("div");
	html.innerHTML = cartData;

	const cartObj = JSON.parse(
			html.querySelector("[data-json-response]").innerHTML
		),
		items = cartObj.items;

	for (let i = 0; i < items.length; i++) {
		// Collect LineItem properties
		let currentProperties = Object.keys(items[i].properties);
		let customAttributes = [];
		for (let j = 0; j < currentProperties.length; j++) {
			let customAttr = `{
				key: "${currentProperties[j]}",
				value: "${items[i].properties[currentProperties[j]]}"
			}`;

			customAttributes.push(customAttr);
		}
		let stringCustomAttributes = customAttributes.join();

		// Create LineItems objects
		let item = `{
			customAttributes: [${stringCustomAttributes}],
			quantity: ${items[i].quantity},
			variantId: "${selectors.helpers.publicVariantId + items[i].variant_id}"
		}`;

		lineItems.push(item);
	}

	CreateCheckout(lineItems);
}

function CreateCheckout(lineItems) {
	//checkoutCreate https://shopify.dev/api/storefront/2022-01/mutations/checkoutCreate
	let mutationGraphQL = `
	mutation {
		checkoutCreate(input: { lineItems: [${lineItems}]}) {
			checkout {
				id
				webUrl
				lineItems(first: 1) {
					edges {
						node {
							id
							variant {
								id
							}
						}
					}
				}
			}
			checkoutUserErrors {
				code
				field
				message
			}
		}
	}`;

	fetch(selectors.helpers.apiVersion, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			"X-Shopify-Storefront-Access-Token": selectors.helpers.checkoutKey
		},
		body: JSON.stringify({
			query: mutationGraphQL
		})
	})
		.then((response) => response.json())
		.then((data) => {
			CheckoutUpdate(data);
		})
		.catch((error) => {
			console.error("Error:", error);
		});
}

function CheckoutUpdate(checkoutObj) {
	const checkout = checkoutObj.data.checkoutCreate.checkout;

	if (checkout) {
		// Write all token to cookies
		document.cookie = "__shopify_checkout_token=" + checkout.id;
		sessionStorage.setItem("__shopify_checkout_token", checkout.id);

		if (document.cookie.includes("__shopify_checkout_token")) {
			window.location.replace(checkout.webUrl);
		} else {
			console.error("Custom AVS checkout. Check cookies");
			alert(
				"Checkout error. Page reload after 5sec. If this message is repeated please contact us."
			);
			setTimeout(() => {
				location.reload();
			}, 5000);
		}
	} else {
		document.cookie = "__shopify_checkout_token=false";
		sessionStorage.setItem("__shopify_checkout_token", "false");
		window.location.replace("/checkout");
	}
}
